import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import Header from "./components/Header";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Products from "./components/Products";
import NotFound from "./pages/NotFound";
import Home from "./pages/Home";
import AltinSlider from "./components/AltinSlider";
import FullscreenPrices from "./pages/FullscreenPrices";
import Bilgitoplum from "./components/Bilgitoplum";
import { ThemeProvider } from "./contexts/ThemeContext";
import { LanguageProvider } from "./contexts/LanguageContext";
import "./App.css"; // Stil dosyası eklendi

const App: React.FC = () => {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <Router>
          <div className="app-container">
            <Header />
            <Navbar />
            <main className="main-content">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/products" element={<Products />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/altin" element={<AltinSlider />} />
                <Route path="/fullscreen" element={<FullscreenPrices />} />
                <Route path="/bilgitoplum" element={<Bilgitoplum />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </Router>
      </LanguageProvider>
    </ThemeProvider>
  );
};

export default App;
